import axios from 'axios'
import CONSTS from '@const/constants'
import auth from '@/api/auth/auth'

export default () => {
  const token = localStorage.getItem('token');
  const instance = axios.create({
    baseURL: CONSTS.BASE_URL,
    // Necesario para que el navegador envíe la cookie HttpOnly del refresh token
    // (front y back son orígenes distintos incluso en local, por puerto).
    withCredentials: true,
    headers: {
      'Accept': 'application/ld+json',
      'Content-Type': 'application/ld+json',
      'Authorization': 'Bearer ' + token
    },
  })

  // Ante un 401 (access token expirado), intenta una renovación silenciosa vía
  // /api/token/refresh (cookie HttpOnly) y reintenta la petición original una
  // única vez. Si la renovación también falla, cierra sesión.
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status !== 401 || originalRequest?._retried) {
        return Promise.reject(error);
      }
      originalRequest._retried = true;

      try {
        const newToken = await auth.silentRefresh();
        originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
        return axios(originalRequest);
      } catch (refreshError) {
        await auth.logout({ preserveRedirect: true });
        return Promise.reject(error);
      }
    }
  );

  return instance;
}
